/* eslint-disable @typescript-eslint/naming-convention */

import request from './request';
export function getAuth(verifyType: string, appid: string, game: string) {
  return request({
    method: 'get',
    path: 'https://app.ingame.qq.com/ingamego/trpc/user-data/get',
    withCredentials: true,
    params: {
      // 用户授权 角色查询服务专用，site_id无需更改。
      site_id: 5,
      login_type: 'slug',
      verify_type: verifyType,
      appid,
      game,
    },
  })
    .then((ret: any) => {
      if (ret && ret.code === 0) {
        return ret.data;
      }
      throw new Error(ret.msg);
    });
}

export function setAuth(verifyType: string, site: string, value: 0 | 1, appid: string, game: string) {
  return request({
    method: 'get',
    path: 'https://app.ingame.qq.com/ingamego/trpc/user-data/set_i32',
    withCredentials: true,
    params: {
      attr: site,
      value,
      site_id: 5,
      login_type: 'slug',
      verify_type: verifyType,
      appid,
      game,
    },
  })
    .then((ret: any) => {
      if (ret && ret.code === 0) {
        return ret.data;
      }
      throw new Error(ret.msg);
    });
}

export function unBindRole(site: string, loginType: string) {
  return request({
    method: 'delete',
    path: 'delete',
    withCredentials: true,
    headers: {
      'Content-type': 'application/json',
    },
    params: {
      site,
      login_type: loginType,
      login_sdk: 'slug',
    },
  });
}


interface getRoleApiParams {
  site: string;
  game: string;
  loginType: LoginType;
}

export function getRole(params: getRoleApiParams) {
  const { site, loginType, game } = params;
  return request({
    method: 'get',
    path: 'display',
    withCredentials: true,
    params: {
      game,
      site,
      login_type: loginType,
      login_sdk: 'slug',
    },
  })
    .then((res: any) => {
      if (res && res.code === 200) {
        const roleInfo = res.result;
        const params = {
          site,
          loginType,
          area: roleInfo.area,
          platid: roleInfo.platid,
          partition: roleInfo.partition,
        };
        syncRole(params, roleInfo.charac_no);
        return roleInfo;
      }
      throw res;
    })
    .catch((err) => {
      throw err;
    });
}

interface bindRoleApiParams {
  site: string;
  token: string;
  loginType: LoginType;
}

export function bindRole(params: bindRoleApiParams) {
  const { site, token, loginType } = params;
  return request({
    method: 'post',
    path: 'bind',
    withCredentials: true,
    headers: {
      'Content-type': 'application/json',
    },
    params: {
      site,
      login_type: loginType,
      login_sdk: 'slug',
    },
    data: {
      token,
    },
  });
}

interface queryRoleApiParams {
  isTest?: number;
  site: string;
  area: number | '';
  platid: 1 | 0 | '';
  partition?: number | '';
  loginType: LoginType;
}

export function queryRole(params: queryRoleApiParams) {
  const { site, area, platid, partition, loginType, isTest } = params;
  return request({
    method: 'post',
    path: 'query',
    withCredentials: true,
    headers: {
      'Content-type': 'application/json',
    },
    params: {
      site,
      login_type: loginType,
      login_sdk: 'slug',
    },
    data: {
      is_test: isTest || 0,
      area,
      platid,
      partition,
    },
  });
}

/**
 * 是否时间戳已经过期
 * 过期时间：一周
 * @param  {Int}  timestamp
 * @return {Boolean}
 */
function isExpire(timestamp: number) {
  const WEEK = 1000 * 60 * 60 * 24 * 7;

  return Date.now() - timestamp > WEEK;
}

/**
 * 同步最新的昵称信息
 * @param  {Object} roleInfo
 */
function syncRole(params: queryRoleApiParams, cname: string): any {
  const { site, loginType } = params;
  const last = localStorage.getItem('LAST_SYNC_ROLE');
  if (!last || isExpire(Number(last))) {
    return queryRole(params)
      .then((res: any) => {
        if (res.result.length > 0) {
          return res.result;
        }
        throw new Error('No role');
      })
      .then((roleList) => {
        interface Role {
          characName: string;
          token: string;
        }
        const role: Role = roleList.find((item: any) => item.charac_no === cname);

        if (!role) {
          throw new Error('charac_no查询失败');
        }
        const { token, characName } = role;

        localStorage.setItem('LAST_SYNC_ROLE', JSON.stringify(Date.now()));
        if (characName !== cname) {
          return bindRole({
            site,
            token,
            loginType,
          });
        }

        console.info('游戏昵称无需更新');
        return 'No changed';
      })
      .catch((err) => {
        console.error('Sync failed', err);
      });
  }
}

export function getSelectJson(game: string, allowPlatForm: LoginType[]): Promise<ServerSelect> {
  let pt = 'WX_';
  const allowWX = allowPlatForm.indexOf('wx') >= 0;
  const allowQQ = allowPlatForm.indexOf('qq') >= 0;
  if (allowQQ) {
    pt = 'SQ_';
  }
  if (allowQQ && allowWX) {
    pt = '';
  }
  // switch (loginType) {
  //   case 'qq' :
  //     pt = 'SQ_';
  //     break; // 可选
  //   case 'wx' :
  //     pt = 'WX_';
  //     break; // 可选
  // }

  // if (!pt) {
  //   throw 'gameTools: 当前未登录';
  // }
  // const timestamp = Date.now();

  const path = window.location.host === 'gzhcos.qq.com' ? '//gzhcos.qq.com' : '//idcgzhcos-10014007.file.myqcloud.com';

  return request({
    path: `https://${path}/game_area/${game}_${pt}server_select.json?t=${Date.now()}`,
    method: 'get',
  }) as Promise<ServerSelect>;
}
